<div class="w-100 d-flex h-100 flex-column align-items-stretch">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/components/layout-account-container/layout-account-container.component.html